import { useState } from "react";
import { CompanyTargetInterface, MultyPlanInterface, PlanInterface, PlanResponse, PlanStoreInterface, PlanStoreKey, PlanTypeInterface } from "../model/plan.types";

export const usePlanStore = (): PlanStoreInterface => {
  const [loading, updateLoadingState] = useState<Record<PlanStoreKey, boolean>>({
    myPlans: false,
    myMultyPlans: false,
    planTypes: false,
    createPlan: false,
    createMultyPlan: false,
    delete: false,
    update: false,
    getCompanyTargets: false,
    getResultUserPlans: false
  });
 
  const [error, updateErrorState] = useState<Record<PlanStoreKey, string | null>>({
    myPlans: null,
    myMultyPlans: null,
    planTypes: null,
    createPlan: null,
    createMultyPlan: null,
    delete: null,
    update: null,
    getCompanyTargets: null,
    getResultUserPlans: null
  });

  const setLoadingState = (key: PlanStoreKey, value: boolean) => {
    updateLoadingState(prev => ({ ...prev, [key]: value }));
  };

  const setErrorState = (key: PlanStoreKey, value: string | null) => {
    updateErrorState(prev => ({ ...prev, [key]: value }));
  };

  const [myPlans, setMyPlans] = useState<PlanInterface[] | null>([])
  const [myMultyPlans, setMyMultyPlans] = useState<MultyPlanInterface[]>([])
  const [planTypes, setPlanTypes] = useState<PlanTypeInterface[]>([])
  const [companyTargets, setCompanyTargets] = useState<CompanyTargetInterface[]>([])
  const [resultMyPlans, setResultMyPlans] = useState<PlanResponse>([])
  return{
    loading, setLoadingState,
    error, setErrorState,
    myPlans, setMyPlans,
    myMultyPlans, setMyMultyPlans,
    planTypes, setPlanTypes,
    companyTargets, setCompanyTargets,
    resultMyPlans, setResultMyPlans
  }
}